// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#admin-snapshot[data-v-31d109f8]{height:calc(100vh - 100px);min-width:1000px;overflow-y:scroll}.v-btn.no-height-limit[data-v-31d109f8]{height:auto!important}.admin-data-column[data-v-31d109f8]{width:50%}.admin-preview-btn[data-v-31d109f8],.admin-view-class[data-v-31d109f8]{font:700 10px;color:#0062ff;cursor:pointer}.admin-list-data-item.el-tag[data-v-31d109f8]{background-color:#fff;border-color:#eaeaea;border-radius:15px;display:inline;line-height:0}", ""]);
// Exports
module.exports = exports;
